
const dpm = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/boy.webp"
const dpf = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/girl.webp"

const swayam = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/swayam.webp"
const robotics = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/robotics.webp"
const placement = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/placement.webp"
const cover = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Cover/mech_banner.webp"

//     SAE Participation
const baja = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/BAJA-2014.webp"
const bicycle = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/bicycle.webp"
const efficar = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/EFFICAR-2015.webp"
const efficycle = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/efficycle.webp"
const gokart = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/GO+Kart-2016.webp"
const solar15 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/solar-2015.webp"
const solar18 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/solar-2018.webp"
const supra = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/SUPRA+-2014.webp"
const tractor = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/SAE/tractor-2018.webp"

//    Elite Rankers
const akhilesh_22 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Elite_rankers/akhilesh_22.webp"
const pooja_23 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Elite_rankers/pooja_23.webp"
const Rakshana_21 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Elite_rankers/Rakshana_21.webp"
const santhosh_23 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Elite_rankers/santhosh_23.webp"
const satheysh_22 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Elite_rankers/satheysh_22.webp"

//    Lab Facilities
const Air_Machinery = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Air_Machinery_lab.webp"
const CAD_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/CAD_lab.webp"
const CAM_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/CAM_lab.webp"
const Dynamics_Machinery_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Dynamics_Machinery_lab.webp"
const EP_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/EP_lab.webp"
const Centre_of_Excellence = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Centre_of_Excellence.webp"
const Eyantra = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Eyantra.webp"
const Fuels_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Fuels_lab.webp"
const Heat_Transfer_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Heat_Transfer_lab.webp"
const K_M_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/K_M_lab.webp"
const Mechatronics_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Mechatronics_lab.webp"
const Metrology_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Metrology_lab.webp"
const MT_I = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/MT_I.webp"
const MT_II = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/MT_II.webp"
const Solar_Power_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Solar_Power_lab.webp"
const Thermal_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Thermal_lab.webp"
const Fluid_Mechanics = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Thermal_lab.webp"

//    Teaching Faclties
const Ramanathan = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/1.Dr.K.Ramanathan+Prof+%26+Head.webp"
const Sankarapandian = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/2.Dr.S.Sankarapandian+Asso+Prof+%26+Head.webp"
const Geetha = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/3.Dr.S.GEETHA.webp"
const Sarala = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/4.Dr.R.Sarala.webp"
const Sivagami = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/5.Dr.S.M.SIVAGAMI.webp"
const Selvaraj = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/6.Prof.S.Selvaraj+AP(Sr.Gr).webp"
const Jawahar = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/7.Prof.V.Jawahar+AP.webp"
const Senthilkumar = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/14.Dr.C.R.Senthilkumar+AP.webp"
const Perumal = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/9.Prof.P.Perumal+AP.webp"
const Rajavijay = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/10.Prof.T.Rajavijay+AP.webp"
const Prema = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/11.Prof.P.Prema.webp"
const Raveendran = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/12.Dr.P.Raveendran+Asso+Prof(CAS).webp"
const Senthil = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/8.Prof.S.Senthilkumar+AP.webp"
const Guruprasad = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/15.Dr.B.Guruprasad+AP(Sl.Gr).webp"
const Babu = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/16.Dr.N.Babu+AP.webp"
const Syed = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/17.Mr.A.Syed+Abdulla+AP(Contract).webp"
const Muruganandham = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/18.Mr.K.Muruganandham+AP(Contract).webp"
const Elumalai = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/19.Mr.P.Elumalai+AP(Contract).webp"
const Sathishkumar = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/20.Mr.C.Sathishkumar+AP(Adhoc).webp"
const Rajakumar = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/21.Mr.N.Rajakumar+AP(Adhoc).webp"
const Karthikeyan = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/22.Mr.K.Karthikeyan+AP(Adhoc).webp"
const Sakthi = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/23.Dr.RM.SakthiSadhasivam+AP(Adhoc).webp"
const PRABH = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/13.Dr.J.Prabakaran+Asso+Prof(CAS).webp"
const karthik_raja = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/karthikraja.webp"
const muthu_raja = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/muthuraja.webp"
const senthil_raja = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/senthilraja.webp"
const Athijayamani = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/athijaya.webp"

//    Supporting Faclties
const Pravakaran = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/A.PRABH.webp"
const MUTHU = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/A.MUTHU.webp"
const UNNIKRISHNAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/B.UNNIKRISHNAN.webp"
const SOLAIYAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/L.SOLAIYAN.webp"
const KALAIYARASAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/M.KALAIYARASAN.webp"
const NAGARAJAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/M.NAGARAJAN.webp"
const SATHISHKUMAR = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/M.SATHISH+KUMAR.webp"
const RAMANATHAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/N.RAMANATHAN.webp"
const PRAKASH = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/P.PRAKASH.webp"
const Kannan = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/R.KANNAN.webp"
const THIRUGNANAM = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/R.THIRUGNANAM.webp"
const VANMIGIVASUDEV = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/R.VANMIGI+VASUDEV.webp"
const VEERAMOHAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/R.VEERAMOHAN.webp"
const VELPANDI = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/R.VELPANDI.webp"
const VENKATRAMAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/R.VENKATRAMAN.webp"
const SARAVANAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/S.SARAVANAN.webp"
const MURUGAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/T.MURUGAN.webp"
const RAVICHANDRAN = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Supporting_fac/V.RAVICHANDRAN.webp"


const mech_dept_menu = [
  {
    id: "1",
    path: "/mechdept",
    link: "About the Department",
    arl: 'l'
  },
  {
    id: "2",
    path: "/mechdept/mech-peo",
    link: "Programme Objectives & Outcomes",
    arl: 'l'
  },
  {
    id: "3",
    path: "/mechdept/mech-faculties",
    link: "Faculty",
    arl: 'l'
  },
  {
    id: "4",
    path: "/mechdept/mech-lab",
    link: "Laboratory Facilities",
    arl: 'l'
  },
  {
    id: "11",
    path: "/mechdept/mech-library",
    link: "Department Library",
    arl: "l",
  },

  // {
  //   id: "8",
  //   path: "#",
  //   link: "Professional Socities",
  //   arl:'l'
  // },
  {
    id: "9",
    path: "/mechdept/mech-phd",
    link: "Research and Publications",
    arl: 'l'
  },
  {
    id: "12",
    path: "/mechdept/mech-dept-events",
    link: "Department Events",
    arl: "1",
  },
  {
    id: "13",
    path: "/mechdept/mech-rankers",
    link: "Elite Rankers",
    arl: 'l',
  },
  {
    id: "10",
    path: "/mechdept/mech-sae",
    link: "SAE Participation",
    arl: 'l'
  },


  // {
  //   id: "11",
  //   path: "#",
  //   link: "MoU",
  //   arl:'l'
  // },
  {
    id: "12",
    path: "/mechdept/mech-centre-of-excellance",
    link: "Centre of Excellence",
    arl: 'l'
  },
  {
    id: "13",
    path: "/mechdept/mech-achievements",
    link: "Achievements",
    arl: 'l'
  },
  {
    id: "14",
    path: "/mechdept/mechasso",
    link: "Association (MEA)",
    arl: 'l'
  }
];

const mech_vision = {
  id: "1",
  visiondata:
    "To become a center of excellence and to produce high quality, self-motivated, creative and ethical engineers and technologists, contributing effectively to universal science and contemporary developments for the benefit of the society.",
};
const mech_mission = [
  {
    id: "1",
    mission:
      "To impart high quality Engineering education and to inculcate ethics to the Students.",
  },
  {
    id: "2",
    mission:
      "To adopt the best pedagogical methods in order to maximize knowledge transfer.",
  },
  {
    id: "3",
    mission:
      "To have adequate mechanisms to enhance understanding of implementation of theoretical concepts in practical scenarios and make the students readily employable in industries.",
  },
  {
    id: "4",
    mission:
      "To carry out high quality research leadings to the creation and commercialization of intellectual property.",
  },
  {
    id: "5",
    mission:
      "To provide the best facilities, infrastructure, and environment to the students, researchers and faculty members, creating an ambience conductive for excellence in technical education.",
  },
];
const mech_progs = [
  {
    id: "1",
    year: "1952",
    // period:"4 Years",
    top_head: "B.E.",
    program: "Mechanical Engineering",
    intake: "120",
  },
  {
    id: "2",
    year: "1971",
    // period:"4 Years",
    top_head: "Part time B.E.",
    program: "Mechanical Engineering",
    intake: "60",
  },
  {
    id: "3",
    year: "2002",
    // period:"4 Years",
    top_head: "M.E.",
    program: "Manufacturing Engineering",
    intake: "18",
  },
  {
    id: "4",
    year: "2002",
    // period:"4 Years",
    top_head: "M.E.",
    program: "Computer Aided Design",
    intake: "18",
  },

];

const mech_peo = [
  {
    id: "1",
    head: "PEO 1",
    house: "left",
    content:
      "To provide a strong foundation in Mathematics, Basic Sciences and Engineering fundamentals required to excel in Mechanical Engineering",
  },
  {
    id: "2",
    head: "PEO 2",
    house: "right",
    content:
      "To prepare students with good scientific, analytical and applied skills to design and analyze engineering products",
  },
  {
    id: "3",
    head: "PEO 3",
    house: "left",
    content:
      "To motivate the students for lifelong learning, entrepreneurship abilities with ethical values.",
  },
  {
    id: "4",
    head: "PEO 4",
    house: "right",
    content:
      "To train the students to have effective communication, team building, leadership and decision making so as to be a successful professional engineer fulfilling societal needs",
  },
];

const mech_outcomes = [
  {
    id: "1",
    point:
      "Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
  },
  {
    id: "2",
    point:
      "Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.",
  },
  {
    id: "3",
    point:
      "Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for the public health and safety, and the cultural, societal, and environmental considerations.",
  },
  {
    id: "4",
    point:
      "Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of the information to provide valid conclusions.",
  },
  {
    id: "5",
    point:
      "Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of the limitations.",
  },
  {
    id: "6",
    point:
      "Apply reasoning informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
  },
  {
    id: "7",
    point:
      "Understand the impact of the professional engineering solutions in societal and environmental contexts, and demonstrate the knowledge of, and need for sustainable development.",
  },
  {
    id: "8",
    point:
      "Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
  },
  {
    id: "9",
    point:
      "Function effectively as an individual, and as a member or leader in diverse teams, and in multidisciplinary settings.",
  },
  {
    id: "10",
    point:
      "Communicate effectively on complex engineering activities with the engineering community and with society at large, such as, being able to comprehend and write effective reports and design documentation, make effective presentations, and give and receive clear instructions.",
  },
  {
    id: "11",
    point:
      "Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
  },
  {
    id: "12",
    point:
      "Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.",
  },
];


const mech_spec_outcomes = [
  {
    id: "1",
    point:
      "To provide cost effective and environmental friendly solution to mechanical engineering problems.",
  },
  {
    id: "2",
    point:
      "To produce creative engineers who can work effectively in design and manufacturing environment.",
  },
  {
    id: "3",
    point:
      "To impart  knowledge for the advancement in the area of modern materials and automobiles.",
  },
];
const mech_rankers = [
  {
    head: "2019-2023 Batch",
    rankers: [
      {
        id: "1",
        cover: cover,
        dp: pooja_23,
        name: "Pooja Sri V",
        Designation: "First rank holder",
        mailid: "1912068",
      },
      {
        id: "2",
        cover: cover,
        dp: santhosh_23,
        name: "Santhosh Kumar S",
        Designation: "Second rank holder",
        mailid: "1912084",
      },
    ]
  },
  {
    head: "2018-2022 Batch",
    rankers: [
      {

        id: "3",
        cover: cover,
        dp: satheysh_22,
        name: "Satheysh Paval P",
        Designation: "First rank holder",
        mailid: "1912068",

      },

      {
        id: "4",
        cover: cover,
        dp: akhilesh_22,
        name: "Akhilesh RN",
        Designation: "Second rank holder",
        mailid: "1812301",
      },

    ]
  },
  {
    head: "2017-2021 Batch",
    rankers: [
      {
        id: "5",
        cover: cover,
        dp: Rakshana_21,
        name: "Rakshana A",
        Designation: "First rank holder",
        mailid: "1712078",
      },
      {
        id: "6",
        cover: cover,
        dp: dpm,
        name: "Vishnubabu",
        Designation: "Second rank holder",
        mailid: "1712111",
      },

    ]

  }
]




const mech_fac_profiles = [
  {
    id: "1",
    cover: cover,
    dp: Ramanathan,
    name: "Dr.K.Ramanathan",
    Designation: "Professor & Head",
    mailid: "ramsananthi@gmail.com",
    pdf: "https://drive.google.com/file/d/1RRcE1m8PZoikgh1IO1c7rJey75LKnRSm/view?usp=sharing",

  },
  {
    id: "2",
    cover: cover,
    dp: Sankarapandian,
    name: "Dr.S.Sankarapandian",
    Designation: "Associate Professor",
    mailid: "sankarsaba@yahoo.com",
    pdf: "https://drive.google.com/file/d/1rGC4PQD03PjAaXxL_WQfXRFZmC0EOw_H/view?usp=sharing",

  },
  /* {
     id: "2",
     cover: cover,
     dp: Athijayamani,
     name: "Dr.A.Athijayamani",
     Designation: "Associate Professor",
     mailid: "athimania@gmail.com",
     pdf: "https://drive.google.com/file/d/1fot9OK8BzcgprLOdmmqEQs0X5LJm9h3z/view?usp=sharing",
 
   },*/
  {
    id: "3",
    cover: cover,
    dp: Geetha,
    name: "Dr.S.Geetha",
    Designation: "Associate Professor ",
    mailid: "gitskumaresh@gmail.com",
    pdf: "https://drive.google.com/file/d/1CGoWXRb2pFeQoL4EvHqkbWo5QNtAWYIR/view?usp=sharing",

  },
  {
    id: "4",
    cover: cover,
    dp: Sarala,
    name: "Dr.R.Sarala",
    Designation: "Associate Professor",
    mailid: "r.sarala@accetedu.in",
    pdf: "https://drive.google.com/file/d/1aEGWxeQ_g2LDrMI8aoEX3Fvlp4gnQG8o/view?usp=sharing",
  },
  {
    id: "5",
    cover: cover,
    dp: Sivagami,
    name: "Dr.S.M.Sivagami",
    Designation: "Associate Professor",
    mailid: "smshivagami@gmail.com",
    pdf: "https://drive.google.com/file/d/1BNytYW_hcXud6m6Z5RYlqWSZz1RsWuf1/view?usp=sharing",
  },
  {
    id: "6",
    cover: cover,
    dp: Selvaraj,
    name: "Prof.S.Selvaraj",
    Designation: "Assistant Professor(Sr.Gr)",
    mailid: "selvamraj1@gmail.com",
    pdf: "https://drive.google.com/file/d/16mekXJbyIwTyaleioUDC0xYc9shTLdkS/view?usp=sharing",
  },
  {
    id: "7",
    cover: cover,
    dp: Jawahar,
    name: "Prof.V.Jawahar",
    Designation: "Assistant Professor",
    mailid: "vjawahar06@gmail.com",
    pdf: "https://drive.google.com/file/d/1qNT9JG3rhLWi5aLZp6qIfWw8AwfbYB7C/view?usp=sharing",
  },
  {
    id: "8",
    cover: cover,
    dp: Senthil,
    name: "Prof.S.Senthilkumar",
    Designation: "Assistant Professor",
    mailid: "s.senthilkumar@accetedu.in",
    pdf: "",
  },
  {
    id: "9",
    cover: cover,
    dp: Perumal,
    name: "Prof.P.Perumal",
    Designation: "Assistant Professor",
    mailid: "perumalaccet@gmail.com",
    pdf: "https://drive.google.com/file/d/1_YIkWFOA2iam7I3gF1pm5t-moMyrvB88/view?usp=sharing",
  },
  {
    id: "10",
    cover: cover,
    dp: Rajavijay,
    name: "Prof.T.Rajavijay",
    Designation: "Assistant Professor",
    mailid: "kingsvijay1503@gmail.com",
    pdf: "https://drive.google.com/file/d/1JP325kv0uZcgAFufRa9oajgMf7yqiL8N/view?usp=sharing",
  },
  // {
  //   id: "11",
  //   cover: cover,
  //   dp: Prema,
  //   name: "Prof.P.Prema",
  //   Designation: "Assistant Professor",
  //   mailid: "paulrajprema7@gmail.com",
  //   pdf: "https://drive.google.com/file/d/1E2DlfH_I9PA7F9MGt7U2tSOB-7Ty6cWa/view?usp=sharing",
  // },
  /* {
     id: "12",
     cover: cover,
     dp: Raveendran,
     name: "Dr.P.Raveendiran",
     Designation: "Associate Professor(CAS)",
     mailid: "praveendiran@gmail.com",
     pdf: "https://drive.google.com/file/d/1cz8L9qzPFqF6Rjs-KiOEPaHZO1HqS5ae/view?usp=sharing",
   },*/
  {
    id: "13",
    cover: cover,
    dp: PRABH,
    name: "Dr.J.Prabakaran",
    Designation: "Associate Professor(CAS)",
    mailid: "jp_au@yahoo.com ,",
    pdf: "https://drive.google.com/file/d/1CHaWoR-zK1TBAReBv8n7OCG1TKVyu3k0/view?usp=sharing",
  },
  {
    id: "14",
    cover: cover,
    dp: Senthilkumar,
    name: "Dr.C.R.Senthilkumar",
    Designation: "Assistant Professor",
    mailid: "ausenthilkumar@gmail.com",
    pdf: "https://drive.google.com/file/d/11sh4xa_PdmLKhIjUvOOyGNMSg6ME5-_w/view?usp=sharing",
  },
  {
    id: "15",
    cover: cover,
    dp: Guruprasad,
    name: "Dr.B.Guruprasad",
    Designation: "Assistant Professor(Sl.Gr)",
    mailid: "tellprasadcdm@gmail.com ",
    pdf: "https://drive.google.com/file/d/18aUYs0pssl7CMF6pFvGLWnZBA8kbWg1R/view?usp=drive_link",
  },
  {
    id: "16",
    cover: cover,
    dp: Babu,
    name: "Dr.N.Babu",
    Designation: "Assistant Professor",
    mailid: "babu.manu11@gmail.com",
    pdf: "https://drive.google.com/file/d/1hP1X8PxTAevHc1i4b6VdibdVpqEXtOvG/view?usp=sharing",
  },
  {
    id: "17",
    cover: cover,
    dp: Syed,
    name: "Mr.A.Syed Abdullah",
    Designation: "Assistant Professor(Contract)",
    mailid: "abdullahh50@gmail.com",
    pdf: "https://drive.google.com/file/d/190M9ingHxoihRh8-NW-8yGDze4rmbR2B/view?usp=sharing",
  },
  {
    id: "18",
    cover: cover,
    dp: Muruganandham,
    name: "Mr.K.Muruganandham",
    Designation: "Assistant Professor(Contract)",
    mailid: "muruganandham.k90@gmail.com",
    pdf: "https://drive.google.com/file/d/1AuE98PlE5mo0NDADT8sELqjf0vfr0BGc/view?usp=sharing",
  },
  {
    id: "19",
    cover: cover,
    dp: Elumalai,
    name: "Mr.P.Elumalai",
    Designation: "Assistant Professor(Contract)",
    mailid: "thiyakuelumalai582@gmail.com",
    pdf: "https://drive.google.com/file/d/1-DcEN3CWc_eONmgs86Beax11IGYE7Beu/view?usp=sharing",
  },
  {
    id: "20",
    cover: cover,
    dp: Sathishkumar,
    name: "Mr.C.Sathiskumar",
    Designation: "Assistant Professor (Consolidated Pay)",
    mailid: "sathishkumarcsk94@gmail.com",
    pdf: "https://drive.google.com/file/d/1ZBb747JVT16bs2Tlmu4UlcdtFHExXJIF/view?usp=sharing",
  },
  {
    id: "21",
    cover: cover,
    dp: Rajakumar,
    name: "Mr.N.Rajakumar",
    Designation: "Assistant Professor (Consolidated Pay)",
    mailid: "rajvalli74@gmail.com",
    pdf: "https://drive.google.com/file/d/1SMWmKWWoYAPNPufp3VowcZR-VPpaPTBd/view?usp=sharing",
  },
  {
    id: "22",
    cover: cover,
    dp: Karthikeyan,
    name: "Mr.K.Karthikeyan",
    Designation: "Assistant Professor (Consolidated Pay)",
    mailid: "kkshare2020@gmail.com",
    pdf: "https://drive.google.com/file/d/13AAP4pt4tSa2zDAxg5gLV0E_PMP6xFK4/view?usp=sharing",
  },

  // {
  //   id: "23",
  //   cover: cover,
  //   dp: Sakthi,
  //   name: "Dr.RM.Sakthi Sadhasivam",
  //   Designation: "Assistant Professor(Adhoc)",
  //   mailid: "sakthi211193@gmail.com",
  //   pdf: "https://drive.google.com/file/d/1tJZVd1B0DYM2PyKGi7pfmPonrI1lqMpA/view?usp=sharing",
  // },
  {
    id: "24",
    cover: cover,
    dp: muthu_raja,
    name: "Dr.R.Muthuraja",
    Designation: "Assistant Professor (Contract)",
    mailid: "muthu.maha92@gmail.com",
    pdf: "https://drive.google.com/file/d/1WeHrnY7V_LCpePhuXphovmIYHeBgJZDa/view?usp=sharing",
  },
  {
    id: "25",
    cover: cover,
    dp: senthil_raja,
    name: "Dr. R. Senthilraja",
    Designation: "Assistant Professor (Contract)",
    mailid: "drrsenthilraja@gmail.com",
    pdf: "https://drive.google.com/file/d/1c4iTkzCiFiCGF_gLOl9ax9reuexOlnrt/view?usp=sharing",
  },
  {
    id: "26",
    cover: cover,
    dp: karthik_raja,
    name: "Dr.M.Karthikraja",
    Designation: "Assistant Professor (Consolidated Pay)",
    mailid: "mkraja0095@gmail.com",
    pdf: "https://drive.google.com/file/d/1t4RGolUIwi1vqMIKM54hgkPL9Rq9ypqi/view?usp=sharing",
  },



];
const mech_sup_profiles = [
  {
    id: "1",
    cover: cover,
    dp: MURUGAN,
    name: "T.Murugan",
    Designation: "Foreman Instructor",
    mailid: "anilmuru.accet@gmail.com",
    pdf: "",
  },
  {
    id: "2",
    cover: cover,
    dp: RAMANATHAN,
    name: "N.Ramanadhan",
    Designation: "junior drafiting officer",
    mailid: "ramanathan.nachiyappan35@gmail.com",
    email_text_overflow: "yes",
    pdf: "",
  },
  {
    id: "3",
    cover: cover,
    dp: SARAVANAN,
    name: "S.Saravanan",
    Designation: " Instructor",
    mailid: "accet123saravanan@gamil.com",
    pdf: "",
  },
  {
    id: "4",
    cover: cover,
    dp: VELPANDI,
    name: "R.Velpandi",
    Designation: " Instructor",
    mailid: "rvelpandi02@gmail.com",
    pdf: "",
  },
  {
    id: "5",
    cover: cover,
    dp: RAVICHANDRAN,
    name: "V.Ravichandran",
    Designation: "Lab Assitant",
    mailid: "ravichandranv50@gmail.com",
    pdf: "",
  },
  {
    id: "6",
    cover: cover,
    dp: KALAIYARASAN,
    name: "M.Kalaiyarasan",
    Designation: "Artisan gr-II",
    mailid: "",
    pdf: "",
  },
  {
    id: "7",
    cover: cover,
    dp: NAGARAJAN,
    name: "M.Nagarajan",
    Designation: "Driver",
    mailid: "nagarajan27246@gmailcom",
    pdf: "",
  },
  {
    id: "8",
    cover: cover,
    dp: UNNIKRISHNAN,
    name: "B.Unnikrishnan",
    Designation: "Lab Assitant",
    mailid: "unnikrishnan.b.mdu@gmail.com",
    pdf: "",
  },
  {
    id: "9",
    cover: cover,
    dp: Kannan,
    name: "R.Kannan",
    Designation: "Lab Assitant",
    mailid: "kannr1048@gmail.com",
    pdf: "",
  },
  {
    id: "10",
    cover: cover,
    dp: PRAKASH,
    name: "P.Prakash",
    Designation: "Machine maistry",
    mailid: "prakash.kavery@gmail.com",
    pdf: "",
  },
  {
    id: "11",
    cover: cover,
    dp: VANMIGIVASUDEV,
    name: "R.Vanmigi vasudev",
    Designation: "ARTISAN GR II ",
    mailid: "vanmigivasudev@gmail.com",
    pdf: "",
  },
  {
    id: "12",
    cover: cover,
    dp: VENKATRAMAN,
    name: "R.Venkatraman",
    Designation: "foundry maistry",
    mailid: "venkatraman6380@gmail.com",
    pdf: "",
  },
  {
    id: "13",
    cover: cover,
    dp: SATHISHKUMAR,
    name: "M.Sathish kumar",
    Designation: "Steam engine Driver",
    mailid: "sathishautmech@gmail.com",
    pdf: "",
  },
  {
    id: "14",
    cover: cover,
    dp: THIRUGNANAM,
    name: "R.Thirugnanam",
    Designation: "ARTISAN GR II",
    mailid: "smartthiru1989@gmail.com",
    pdf: "",
  },
  {
    id: "15",
    cover: cover,
    dp: VEERAMOHAN,
    name: "R.Veeramohan",
    Designation: "Lab Assitant",
    mailid: "veeramohan01@gmail.com",
    pdf: "",
  },
  {
    id: "16",
    cover: cover,
    dp: MUTHU,
    name: "A.Muthu",
    Designation: "Cleaner",
    mailid: "aathimoolammuthu79@gmail.com",
    pdf: "",
  },
  {
    id: "17",
    cover: cover,
    dp: Pravakaran,
    name: "A.Prabhu",
    Designation: "Cleaner",
    mailid: "prabu250586@gmail.com",
    pdf: "",
  },
  {
    id: "18",
    cover: cover,
    dp: SOLAIYAN,
    name: "L.Solaiyan",
    Designation: "Lab Assitant (T)",
    mailid: "solaiyan95@gmail.com",
    pdf: "",
  },
  {
    id: "19",
    cover: cover,
    dp: dpm,
    name: "V.prabhu",
    Designation: "Lab Assitant(T)",
    mailid: "meetprabhu09@gmail.com",
    pdf: "",
  },
  {
    id: "20",
    cover: cover,
    dp: dpm,
    name: "M.Rajeshkannan",
    Designation: "Lab Assitant(T)",
    mailid: "87rajeshkannan@gmail.com",
    pdf: "",
  },
];

const mech_labs = [
  {
    id: '1',
    heading: "Air Machinery Laboratory",
    'sub-head': "Empowering innovation through precision in Air Machinery Laboratory.",
    pic: Air_Machinery,
    link: "https://drive.google.com/file/d/1wNEC3l5744NHxZ0mh_VIwIk1CkRkXhR6/view?usp=drive_link",
    content_1: 'The laboratory was established in the Mechanical Engineering block of the laboratory complex in the year 1952 measuring 146.2 sq.m carpet area. The laboratory comprises major equipments like Kaplan turbine, two stage air compressor, Wind tunnel and Rotary compressor test rig',
    content_2: "These fundamentals will be useful to students to link the phenomenological processes taking place in the engine for issues of power generation, fuel economy and fuel composition effects on engine operation and mechanical limitations of obtaining ideal performance.The laboratory is supported with a laboratory in charge and a Foreman instructor who are responsible for all the day to day activities of the laboratory."
  },
  {
    id: '2',
    heading: "CAD Laboratory",
    'sub-head': 'In the CAD Laboratory, ideas take shape, innovation meets design precision.',
    pic: CAD_lab,
    link: "https://drive.google.com/file/d/1XyNhNHGV9U0thkRHZ3PrSB9eBRDby3dz/view?usp=drive_link",
    content_1:
      "",
    'content_2': "The CAD Laboratory is a common facility of the department where all undergraduate and postgraduate students, research scholars and faculty members can work with the sophisticated 2-D & 3-D design and analysis software. They can learn to use the latest software and carry out their research work. The lab includes 45 computers with CAD software, as well as ANSYS software. The process of design, simulation takes place in a digitally integrated environment."
  },
  {
    id: '3',
    heading: "CAM Laboratory",
    'sub-head': "CAM Laboratory: Crafting Innovations with Precision.",
    pic: CAM_lab,
    link: "https://drive.google.com/file/d/1k0ePjTRkqdZ7UxeSPqjb7gjb2x5NONT-/view?usp=drive_link",
    content_1:
      "",
    content_2: "The CAM Laboratory has been established over an area of 143.8 sq.m. The lab is equipped with CNC milling, CNC lathe, 3 D printing and Rapid prototyping. The objective of this laboratory is to impart skills to the students to operate machines through computer software. This lab is available to graduate the students in the field of Computer Aided Manufacturing. The students also trained through CAM simulation software packages. CNC machines available in the lab can be utilized for UG and PG student’s project work. Laboratory is supported with a laboratory in charge and Technical staff who are responsible for all the day to day activities of the laboratory"
  },
  {
    id: '4',
    heading: "Dynamics of Machinery Laboratory",
    'sub-head': "Dynamic insights drive innovation in our Machinery Lab.",
    pic: Dynamics_Machinery_lab,
    link: "https://drive.google.com/file/d/1TQZJ-HNL61Y9dkmcvzOvAQEG6KZdIY5l/view?usp=drive_link",
    content_1: "The laboratory was established in the Mechanical Engineering block of the laboratory complex in the year 2005 measuring 83 sq.m carpet area. The laboratory comprises major equipment's like Watt Governor, Porter Governor, Hartnell Governor, Proell Governor, whirling of shaft apparatus, Gyroscope and Vibration Laboratory set-up. ",
    'content_2': "Experiments in this lab are related to concepts of courses such as kinematics of machinery, design of machine elements and vibrations for under graduate students. The objective of conducting the practical classes in the laboratory is to develop skills to analyze the various forces acting on a Mechanical system and to identify the unbalanced forces and its effects such as vibration and its control. Apart from conducting the laboratory classes, the lab facilities are effectively utilized for project work by the students. The laboratory is looked after the Laboratory in charge and instructor who undertake the day to day activities of the laboratory"
  },
  {
    id: '5',
    heading: "Fluid Mechanics and Machinery Laboratory",
    'sub-head': 'Precision flows in our Fluid Mechanics Lab.',
    pic: Fluid_Mechanics,
    link: "https://drive.google.com/file/d/1qIHxF0cgYSWtatfW_CKkg0dAPbqGXCY1/view?usp=drive_link",
    content_1: "",
    content_2: "This Laboratory houses equipment's for gaining hands on experience both in the field of Fluid Mechanics and Machinery. Total area covered is 204.7 sq.m including cabin for the laboratory incharge. Turbines like Francis, Kaplan, Pelton Wheel and Pumps like Centrifugal, Jet pump Submersible, Gear pump and reciprocating pump, Orifice meter,  Flow channel with V notch, Experimental set up to determine Pipe friction, Setup for determining metacentric height and models of impellers and pelton wheel are available in the laboratory"
  },
  {
    id: '6',
    heading: "Heat and Mass Transfer Laboratory",
    'sub-head': "Heat and Mass Transfer Lab: Mastering Thermal Dynamics for Innovative Solutions.",
    pic: Heat_Transfer_lab,
    link: "https://drive.google.com/file/d/1TQZJ-HNL61Y9dkmcvzOvAQEG6KZdIY5l/view?usp=drive_link",
    content_1: "",
    content_2: "Heat and Mass Transfer Laboratory was established in the year 1952, with the equipment’s like Heat Ex-changer, Thermal Conductivity Measurement Apparatus, Pin Fin Apparatus, Forced Convection Apparatus, Natural Convection Apparatus, Emissivity Measurement Apparatus, Stefan Boltzmann Apparatus and Lagged Heat Pipe Apparatus. The different modes of heat transfer like Conduction, Convection and Radiation phenomenon are studied with the help of the experiments and equipment's available in the laboratory."
  },
  {
    id: '7',
    heading: "Kinematics of Machinery Laboratory",
    'sub-head': "Precision in motion, our Kinematics Lab drives innovation.",
    pic: K_M_lab,
    link: "https://drive.google.com/file/d/1q7lX4L6iw24S1U-DLXPN_V07wSMJxk22/view?usp=drive_link",
    content_1: "The Kinematics of Machinery Laboratory has been established over an area of 73 sq.m. and is equipped with facilities like Crank rocker, Slider crank mechanism, Involute tooth in contact, Quick return mechanism, Kinematic pairs kit, Epicyclic gear train, Cam profile with follower , Synchronous gear box and Vibration Comprehensive Experimental Teaching System . ",
    content_2: "The objective of this laboratory is to develop skills for designing and analyzing linkages, cams, gears and other mechanisms and also used to provide a foundation for the study of machine design. With the study of rigid bodies motions and forces for the transmission systems, machine kinematics and dynamics can be well understood. The laboratory is supported with a laboratory in charge and Technical staff who are responsible for all the day to day activities of the laboratory"
  },
  {
    id: '8',
    heading: "Thermal Laboratory",
    'sub-head': 'Heat the future with precision expertise at our Thermal Laboratory.',
    pic: Thermal_lab,
    link: "https://drive.google.com/file/d/1s8Y25vaixzqTFS8R5zhcKSRC4lZSfbxw/view?usp=drive_link",
    content_1: "The Thermal Laboratory has been established over an area of 204.7 sq.m. and is equipped with facilities like IC Engines, Steam Engines, turbines and Non- IBR Boiler. The objective of this laboratory is to provide the students a good environment to understand significant concepts and applications in the field of Thermal energy based power generation and utilisation. ",
    'content_2': "These fundamentals will be useful to students to link the phenomenological processes taking place in the engine for issues of: power generation, emissions and environmental impact, fuel economy and fuel composition effects on engine operation and mechanical limitations of obtaining ideal performance.The laboratory is supported with a laboratory in charge and a Foreman instructor who are responsible for all the day to day activities of the laboratory."
  },
  {
    id: '9',
    heading: "Center of Excellence for Smart Manufacturing",
    'sub-head': 'Smart Manufacturing Lab: Innovate, Connect, Transform Industry',
    pic: Centre_of_Excellence,
    link: "https://drive.google.com/file/d/1TxcWDuBED3Hj-R4FQ2hLp9H9bXgC1bI6/view?usp=drive_link",
    content_1: "Welcome to our Center of Excellence for Smart Manufacturing Laboratory, where innovation meets precision in the realm of advanced manufacturing technologies. Our state-of-the-art facility is designed to be a nexus for cutting-edge research, development, and education in the field of smart manufacturing.  ",
    'content_2': "Equipped with the latest Industry 4.0 technologies, our laboratory serves as a hub for interdisciplinary collaboration, bringing together experts from engineering, data science, robotics, and automation. Here, researchers and industry professionals explore the convergence of digital and physical systems to revolutionize the manufacturing landscape. Our facility features a comprehensive suite of tools and equipment, including advanced sensors, IoT devices, augmented reality systems, and artificial intelligence platforms. These resources empower researchers to design and implement innovative solutions that enhance efficiency, optimize production processes, and minimize environmental impact."
  },
  {
    id: '10',
    heading: "Eyantra-Robotics",
    'sub-head': "The  Lab, Inspiring innovation, shaping tomorrow's technology leaders",
    pic: Eyantra,
    link: "https://drive.google.com/file/d/1H7dlzFNlDGT9B4fznC5QQmAV8EwiahaM/view?usp=drive_link",
    content_1: "The Eyantra Robotics Laboratory is a cutting-edge facility dedicated to fostering innovation and hands-on learning in the field of robotics. Equipped with state-of-the-art robotic platforms, advanced sensors, and a comprehensive set of tools, the laboratory provides students with a dynamic environment to explore, experiment, and develop their robotics skills.",
    'content_2': "Students engage in a range of projects, from basic robotics concepts to complex autonomous systems, gaining practical experience that prepares them for real-world challenges. The Eyantra Robotics Laboratory not only focuses on technical aspects but also emphasizes teamwork, problem-solving, and creativity. With a curriculum designed to align with industry standards, students acquire a solid foundation in robotics and automation, enhancing their competitiveness in the ever-evolving job market."
  },
  {
    id: '11',
    heading: "Engineering Practices",
    'sub-head': 'Engineering Practices Lab: Where theory meets hands-on innovation.',
    pic: EP_lab,
    link: "https://drive.google.com/file/d/1__gV1vWA9FE32gJmR5GI1-j5ZgeQAZiO/view?usp=drive_link",
    content_1: "The Engineering Practices Laboratory consists of the Welding, Carpentry, Foundry, Fitting section and sheet metal section. The objective of this laboratory is to study and practice the various operations and to equip with the practical knowledge required in the core industries. This Laboratory is used to provide exposure to the first year students with hands on experience on various basic engineering practices. ",
    'content_2': "Experiments performed in the Carpentry shop include T lap joint, Dove tail lap joint, Mortise and Tenon joints. Students are illustrated with demonstration experiments in the Sheet Metal Shop as part of their syllabus. The Engineering Practices Laboratory is also used for Welding fabrication of projects by the students for their Project works in the 8th Semester, B.E. Mechanical Engineering course. Experiments performed in the Welding shop include Single V-butt joint, double lap joint and T joint."
  },
  {
    id: '12',
    heading: "Manufacturing Technology I",
    'sub-head': "Shaping Tomorrow's Innovation of our nation",
    pic: MT_I,
    link: "https://drive.google.com/file/d/19UochlzsjEmupdI53-vF6bx8-nW_XQdC/view?usp=drive_link",
    content_1: "These practical courses aim to provide the students with practical knowledge in basic machining processes that could be performed in Center lathe, Capstan lathe and Turret lathe etc.. The practical classes provide opportunity for students to visualize essential components of these machines. Students understand the method of operating the machines safely.",
    'content_2': "Also this practical course aims to provide the students with practical knowledge in basic manufacturing processes that could be performed in standard machine tools such as shaping, milling, slotting, grinding and allied machines. The practical classes provide opportunity for students to learn the methods to machine the models to desired accuracy and quality."
  },
  {
    id: '13',
    heading: "Manufacturing Technology II",
    'sub-head': ' Precision that shapes future industries.',
    pic: MT_II,
    link: "https://drive.google.com/file/d/1h-ZDP7M3bqcehNvMhg4GlQMcyLBPUmtl/view?usp=drive_link",
    content_1: "These practical courses aim to provide the students with practical knowledge in basic machining processes that could be performed in Center lathe, Capstan lathe and Turret lathe etc.. The practical classes provide opportunity for students to visualize essential components of these machines. Students understand the method of operating the machines safely.",
    'content_2': "At the end of the second year, student will be capable of demonstrating the various basic operations such as Facing, Step turning, Drilling, tapping, Grooving, Chamfering and Knurling, External thread cutting, Step turning, counter boring, Eccentric turning and Taper turning. Also student will be capable of demonstrating the various basic operations such as shaping square block, machining by single point cutting tool, machining key ways , machining a spur gear, milling a Polygon Surface ,measuring and cutting tool forces etc. ."
  },
  {
    id: '14',
    heading: "Mechatronics",
    'sub-head': 'Mechatronics Lab: Fusing mechanics and electronics for groundbreaking innovation.',
    pic: Mechatronics_lab,
    link: "https://drive.google.com/file/d/1s2u9O_F8XEBGjl8vYuAZ9ps4veW3SbWk/view?usp=drive_link",
    content_1: "The laboratory was established in the Mechanical Engineering block of the laboratory complex in the year 2006, measuring 61.7 sq.m carpet area. The laboratory comprises of computers with Automation studio software and FluidSIM softwares, 8085 Microprocessor Trainer kits, 8051 Microcontroller trainer Kits, PLC Simulator Kit, Hydraulic Trainer kit, Pneumatic Trainer kit and Sensor Trainer Kit. ",
    'content_2': " The objective of conducting the practical classes in the laboratory is to develop the skills in performing design and simulation of fluid power circuits using application softwares like FluidSim and Automation Studio and to test simple circuits using trainer kits. Also the student is trained in programming microprocessor and microcontroller and evaluate the performance of sensors in relation with development of mechatronics system."
  },
  {
    id: '15',
    heading: "Metrology",
    'sub-head': 'Metrology Lab: Where Precision Meets Excellence.',
    pic: Metrology_lab,
    link: "https://drive.google.com/file/d/1yVs9HPofZURzzJqmtf3ecg2xR9op-q6H/view?usp=drive_link",
    content_1: "Explore precision in our Metrology Laboratory. Cutting-edge equipment ensures accurate measurements for quality control. Our expert team guarantees the reliability of your data. From dimensional analysis to calibration services, we provide solutions for diverse industries. Trust us for unparalleled precision and excellence in metrology.",
    'content_2': "The laboratory is to equip students with knowledge on common linear, angular and form measurement analysis by using the instruments meant for engineering measurements. The laboratory equipped with various instruments like Rapid- machine vision system, Sine bar & Slip Gauges, Autocollimator, Gear Roll Tester, Tool Makers Microscope, Impact Tester , Simultaneous Thermal Analyzer (STA) , Compression molding Machine, Bevel protector andFloating carriage micrometer which will be utilized by the students and Research scholar in carry out various studies in the area of Manufacturing."
  },
  {
    id: '16',
    heading: "Solar Power Laboratory",
    'sub-head': "Solar Power Lab: Unleashing Sunlight's Sustainable Energy Potential.",
    pic: Solar_Power_lab,
    content_1: "",
    content_2: "The laboratory was established in the Department of Mechanical Engineering (Lab) during the academic year of 2019-2020 under TEQIP III Grant, it has a 50.0 sq.m carpet area. The Facilities available are as follows: Solar water heater, Solar air heater, Solar cooker, Solar power plant, Pyranometer, Pyrheliometer, Cup Anemometer, Solarimeter. The UG,PG and research scholars are given hands-on training and also to carry out research."
  },
  {
    id: '17',
    heading: "Fuels Laboratory",
    'sub-head': 'Fuels Laboratory: Igniting Quality, Powering Progress.',
    pic: Fuels_lab,
    content_1: "",
    content_2: "The Fuels laboratory provides ample opportunity to the students and the research scholars to test and study different properties of fuels that can be used in IC engine and to do their innovative projects. In fuels lab, several fuel testing equipment's are available to measure, vapour pressure thermometer, Dead weight pressure Gauge, measurement of flash point and fire point of an oil, determination of viscosity of an oil using Saybolt and Engler Viscometer, determination of smoke point, determination of aniline point, determination of cloud and pour point and also experiments are conducted on esterification process, in the production of bio-fuel."
  },

]

const mech_dept_events = [
  {
    'id': '1',
    'heading': 'BAJA ',
    'sub-head': "2014-2015 BAJA SAE event by SAE, Feb 12-15, Pithambur, Indore, 25 participants.",
    'pic': baja,
    'content_1': "In the academic year 2014-2015, a notable event known as BAJA SAE took place under the auspices of the Society of Automotive Engineers (SAE). The event unfolded from February 12th to 15th, 2015, at the challenging terrain of Pithambur, located in the vicinity of the National Automotive Testing and R&D Infrastructure Project (NATRiP) in Indore.",
    'content_2': " BAJA SAE, renowned for its off-road vehicle design and fabrication challenges, drew the participation of 25 enthusiastic teams. This gathering of automotive enthusiasts and engineering minds showcased innovation, technical expertise, and a passion for pushing the boundaries of vehicular design and performance. The event not only provided a platform for friendly competition but also fostered knowledge exchange and collaboration within the automotive engineering community."

  },
  {
    'id': '2',
    'heading': "SUPRA",
    'sub-head': "SAE's 2015 SUPRA event: July 16-19 at MRF Motors Racetrack, Chennai, 25 participants.",
    'pic': supra,
    'content_1': "In July 2015, the MRF Motors Racetrack in Chennai played host to a notable event organized under the banner of SUPRA SAE. Taking place from July 16th to 19th, the event brought together 25 participating societies. With a focus likely centered around automotive engineering and innovation, this gathering provided a platform for enthusiasts and professionals to showcase their skills.",
    'content_2': " The competitive yet collaborative spirit prevailed throughout the event, fostering knowledge exchange and friendly interactions among the participants. The choice of the MRF Motors Racetrack as the venue underscored the significance of the automotive industry in the discussions and activities that unfolded during those days. Overall, the event contributed to the advancement and recognition of the participating societies in the realm of engineering and automotive expertise."
  },
  {
    'id': '3',
    'heading': 'EFFICYCLE 16',
    'sub-head': 'EFFICYCLE 2015-2016 by SAE at LPU, Punjab, had 10 participants.',
    'pic': efficycle,
    'content_1': "During the academic year 2015-2016, an event of significance transpired in the form of EFFICYCLE organized by the Society of Automotive Engineers (SAE). Held from October 16th to 18th, 2015, this event took place at Lovely Professional University (LPU) in Jalandhar, Punjab. The occasion drew the participation of 10 teams, showcasing their prowess in the field, likely emphasizing efficiency and innovation in the realm of cycling.",
    'content_2': "The event at LPU provided a conducive platform for participants to exchange knowledge, compete in a friendly atmosphere, and contribute to the broader discourse on advancements in sustainable transportation. The relatively modest number of participants suggests a more intimate setting, allowing for focused interactions and a deeper engagement with the shared goals of the participants and the overarching objectives of EFFICYCLE."
  },
  {
    'id': '4',
    'heading': 'EFFICARS',
    'sub-head': 'EFFICARS 2015-2016: UIET Chandigarh event, Jan 22-24, 2016, 10 participants.',
    'pic': efficar,
    'content_1': "In the academic year 2015-2016, an impactful event took place in the form of EFFICARS at the University Institute of Engineering and Technology (UIET) in Chandigarh. This event, held from January 22nd to 24th, 2016, brought together a total of 10 participants from UIET, Chandigarh. The gathering served as a platform for students to showcase their skills and engage in meaningful discussions, fostering a collaborative spirit within the academic community.",
    'content_2': " Such events play a crucial role in enhancing the overall learning experience, providing students with opportunities to apply their knowledge and interact with peers in a practical setting. The success of EFFICARS at UIET, Chandigarh, during this period reflects the enthusiasm and commitment of both organizers and participants towards promoting academic excellence and innovation."
  },
  {
    'id': '5',
    'heading': 'EFFICYCLE 17',
    'sub-head': 'EFFICYCLE 2016-2017 by SAE at LPU, Punjab, had 10 participants.',
    'pic': efficycle,
    'content_1': "In the academic year 2016-2017, a notable event named EFFICYCLE took place under the auspices of the Society of Automotive Engineers (SAE). The event unfolded from October 12 to 16, 2016, at Lovely Professional University (LPU) in Jalandhar, Punjab. EFFICYCLE, which attracted a considerable participation of 10 enthusiastic teams, showcased the innovative spirit and engineering prowess of students who engaged in a variety of challenges and competitions. ",
    'content_2': "This gathering not only provided a platform for the exchange of ideas and technical knowledge but also fostered a sense of camaraderie among participants, contributing to the overall growth and development of the automotive engineering community."
  },
  {
    'id': '6',
    'heading': 'TRACTOR DESIGN COMPETITION',
    'sub-head': "SAE's 2017-18 Tractor Design at SRM, Chennai, had 25 participants.",
    'pic': tractor,
    'content_1': "In the academic year 2017-18, a notable event took place in the form of the Tractor Design Competition organized by the Society of Automotive Engineers (SAE). The competition unfolded from June 21 to June 26, 2018, at SRM University in Chennai. This gathering attracted a commendable number of participants, with a total of 25 individuals engaging in the event.",
    'content_2': "The competition, focused on designing innovative and efficient tractors, provided a platform for students to showcase their engineering skills and knowledge in the realm of automotive technology. Such events play a pivotal role in fostering a spirit of creativity and healthy competition within academic and professional circles, contributing to the advancement of technology and engineering prowess."
  },
  {
    'id': '7',
    'heading': 'BICYCLE',
    'sub-head': "SAE's 8th Bicycle event in 2018-19 at Kongu Engg College (Aug 3-4, 2019) had 5 participants.",
    'pic': bicycle,
    'content_1': "In the academic year 2018-19, an exciting event unfolded as the Bicycle competition took center stage under the auspices of the Society of Automotive Engineers (SAE). The event, held on August 3-4, 2019, brought together enthusiasts and participants at Kongu Engineering College in Perundurai. With a total of five participants, the competition showcased the passion and innovation of individuals dedicated to advancing the field of bicycle engineering.",
    'content_2': "The venue, Kongu Engineering College, served as the perfect backdrop for the event, providing a platform for participants to demonstrate their skills and knowledge in the realm of bicycle technology. The event not only fostered healthy competition but also contributed to the exchange of ideas and the promotion of advancements in bicycle engineering. Overall, the 2018-19 Bicycle competition organized by SAE at Kongu Engineering College stood as a testament to the vibrancy and dedication within the community, with five participants making their mark in this dynamic and intellectually stimulating event."
  },
  {
    'id': '8',
    'heading': 'ELECTRIC SOLAR VEHICLE 15',
    'sub-head': "ISIE's 2015 Electric Solar Vehicle event at MM College, Haryana, featured 25 participants.",
    'pic': solar15,
    'content_1': "In the academic year 2014-2015, a significant event unfolded in the realm of innovative engineering—the Electric Solar Vehicle competition organized by the International Society of Innovation and Entrepreneurship (ISIE). This groundbreaking event took place from March 17 to 19, 2015, at MM College in Haryana, India. The competition, centered around the development and showcase of electric solar vehicles, attracted considerable attention and participation from 25 enthusiastic teams.",
    'content_2': "Engineers, designers, and innovators converged at this event to not only demonstrate their prowess in harnessing solar energy for vehicular propulsion but also to exchange ideas and foster a spirit of innovation within the scientific community. The MM College venue served as a hub for intellectual exchange and spirited competition, marking this event as a memorable chapter in the pursuit of sustainable and eco-friendly transportation solutions."
  },

  {
    'id': '9',
    'heading': 'ELECTRIC SOLAR VEHICLE 18',
    'sub-head': "ISIE's 9th Electric Vehicle event (2018-19) at Chandigarh University with 5 participants.",
    'pic': solar18,
    'content_1': "During the academic year 2018-19, the International Society of Innovation and Entrepreneurship (ISIE) continued to propel advancements in sustainable engineering through its Electric Solar Vehicle competition. This particular event unfolded from March 25 to 31, 2019, with the vibrant city of Chandigarh hosting the innovative showcase at Chandigarh University. A total of 5 dedicated teams participated in this edition of the competition, bringing forth their cutting-edge electric solar vehicle designs and technological innovations.",
    'content_2': "The event not only served as a platform for friendly competition but also fostered an environment for collaboration and the exchange of ideas among like-minded individuals. Chandigarh University, with its conducive atmosphere for academic discourse, played a pivotal role in making this event a success, contributing to the ongoing dialogue on sustainable transportation solutions and the integration of solar energy into vehicular systems."
  },
  {
    'id': '10',
    'heading': 'GOKART 16',
    'sub-head': "ISNEE's 2015-2016 GOKART event: Coimbatore, Feb 12-15, 25 participants.",
    'pic': gokart,
    'content_1': "In the year 2015-2016, an exhilarating event unfolded in the world of motorsports as the Indian Society of New Era Engineers (ISNEE) organized a thrilling Gokart competition. This adrenaline-pumping event took place from February 12 to 15, 2016, at the renowned Kari Motors Speedway in Coimbatore. The event attracted a significant participation of 25 enthusiastic individuals, all geared up to showcase their skills and passion for Gokart racing.",
    'content_2': "Against the backdrop of the high-speed tracks and the competitive spirit in the air, participants brought their A-game to this prestigious event, making it a memorable experience for both the racers and the spectators alike. The Gokart event organized by ISNEE in 2015-2016 undoubtedly left an indelible mark on the motorsports landscape, celebrating the thrill of speed, skill, and the pursuit of victory."
  },
  {
    'id': '11',
    'heading': 'GOKART 23',
    'sub-head': "ISNEE's 2023-2024 GOKART event: Coimbatore, Oct 29- Nov 2nd 2023,25 participants.",
    'pic': gokart,
    'content_1': "In the upcoming year of 2023-2024, the Indian Society of New Era Engineers (ISNEE) is set to ignite the racing scene once again with a thrilling Gokart event. Scheduled to take place from October 29 to November 2, 2023, this high-octane competition will unfold at the renowned Kari Motors Speedway in Coimbatore, maintaining the tradition of hosting these adrenaline-fueled races in a premier racing location. Anticipation is building as 25 participants gear up to engage in intense competition, showcasing their driving prowess and passion for Gokart racing.",
    'content_2': "Against the backdrop of the challenging tracks and the electric atmosphere of competition, the event promises to be a riveting experience for both participants and spectators. As the countdown begins for the Gokart event organized by ISNEE in the 2023-2024 season, the stage is set for another thrilling chapter in the world of motorsports, where speed, skill, and the pursuit of victory converge on the tracks of Kari Motors Speedway."
  },
]

const mech_lib_profiles = [
  {
    'id': '1',
    'program': 'Library Books',
    'pdf': 'https://drive.google.com/file/d/1oOjtrfWazkyXW-dKWXSIXdOmjcx3PTBZ/view?usp=sharing'
  },
]
const mech_research_phd = [
  {
    'sno': "1",
    'scholar': "U.Natarajan",
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "Aug-2006"
  },
  {
    'sno': "2",
    'scholar': "P.Seenikannan",
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "Dec-2008"
  },
  {
    'sno': "3",
    'scholar': "K.Ramanathan ",
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "June-2009"
  },
  {
    'sno': "4",
    'scholar': "G.Rajagopal ",
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "June-2009"
  },
  {
    'sno': "5",
    'scholar': "A.Elango",
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "June-2009"
  },
  {
    'sno': "6",
    'scholar': "K.Subramaniyan",
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "Feb-2010"
  },
  {
    'sno': "7",
    'scholar': "S.Jayabal",
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "June-2011"
  },
  {
    'sno': "8",
    'scholar': "S.Sathiyamurthy",
    'supervisor': "Dr.A.SyedAbuThaheer"

    ,
    'month and year': "Mar-2013"
  },
  {
    'sno': "9",
    'scholar': "K.Velmanirajan"

    ,
    'supervisor': "Dr.A.SyedAbuThaheer"

    ,
    'month and year': "Mar-2013"
  },
  {
    'sno': "10",
    'scholar': "A.Kumaravadivel"

    ,
    'supervisor': "Dr.U.Natarajan"

    ,
    'month and year': "May-2013"
  },
  {
    'sno': "11",
    'scholar': "G.Senthilkumar",
    'supervisor': "Dr.U.Natarajan"

    ,
    'month and year': "June-2013"
  },
  {
    'sno': "12",
    'scholar': "S.Palani"

    ,
    'supervisor': "Dr.U.Natarajan"

    ,
    'month and year': "Sep-2013"


  },
  {
    'sno': "13",
    'scholar': "P.R.Periyannan"

    ,
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Oct-2013"


  },
  {
    'sno': "14",
    'scholar': "P.Narasimman"

    ,
    'supervisor': "Dr.V.M.Periyasamy",
    'month and year': "Nov-2013"
  },
  {
    'sno': "15",
    'scholar': "K.Karrupasamy"

    ,
    'supervisor': "Dr.A.SyedAbuThaheer",
    'month and year': "Nov-2014"
  },
  {
    'sno': "16",
    'scholar': "S.Karthikeyan"

    ,
    'supervisor': "Dr.A.Elango",
    'month and year': "Nov-2015"
  },
  {
    'sno': "17",
    'scholar': "M.Balasubramanian"

    ,
    'supervisor': "Dr.K.Ramanathan",
    'month and year': "Dec-2015"


  },
  {
    'sno': "18",
    'scholar': "S.Kalyanasundaram"

    ,
    'supervisor': "Dr.S.Jayabal"

    ,
    'month and year': "Dec-2015"


  },
  {
    'sno': "19",
    'scholar': "S.Rajamuneeswaran"

    ,
    'supervisor': "Dr.S.Jayabal",
    'month and year': "June-2016"


  },
  {
    'sno': "20",
    'scholar': "S.Chockalingam",
    'supervisor': "Dr.U.Natarajan"

    ,
    'month and year': "Sep-2016"
  },
  {
    'sno': "21",
    'scholar': " R.Ram Prasath"

    ,
    'supervisor': " Dr.S.Jayabal"

    ,
    'month and year': " Jan-2017"


  },
  {
    'sno': "22",
    'scholar': "  R.Prithivirajan",
    'supervisor': "  Dr.S.Jayabal"

    ,
    'month and year': " Mar-2017"


  },
  {
    'sno': "23",
    'scholar': "A.P.Mohanraj",
    'supervisor': " Dr.A.Elango"

    ,
    'month and year': " Mar-2017"


  },
  {
    'sno': "24",
    'scholar': "K.Kalaiselvan"

    ,
    'supervisor': "Dr.A.Elango"

    ,
    'month and year': " Apr-2017"


  },
  {
    'sno': "25",
    'scholar': "G.Bharathiraja",
    'supervisor': "Dr.S.Jayabal"

    ,
    'month and year': " May-2017"


  },
  {
    'sno': "26",
    'scholar': "K.Vignesh"

    ,
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Jul-2017"


  },
  {
    'sno': "27",
    'scholar': "R.Joseph Ravi Selvan",
    'supervisor': "Dr.K.Ramanathan",
    'month and year': "Sep-2017"


  },
  {
    'sno': "28",
    'scholar': "Louie Frango.T"

    ,
    'supervisor': "Dr.K.Ramanathan"

    ,
    'month and year': "Nov-2017"


  },
  {
    'sno': "29",
    'scholar': "Hyacinth Suganthi X",
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Nov-2017"


  },
  {
    'sno': "30",
    'scholar': "Marlon Jones Lovis",
    'supervisor': "Dr.R.Malayalamurthi"

    ,
    'month and year': "Sep-2018"
  },
  {
    'sno': "31",
    'scholar': "PrasannaVenkatesh.R"

    ,
    'supervisor': "Dr.K.Ramanathan"

    ,
    'month and year': "Oct-2018"


  },
  {
    'sno': "32",
    'scholar': "Kannan.S"

    ,
    'supervisor': "Dr.K.Ramanathan",
    'month and year': "Feb-2019"
  },
  {
    'sno': "33",
    'scholar': "M.Krishnamoorthy",
    'supervisor': "Dr.R.Malayalamurthi",
    'month and year': "Mar-2019"
  },
  {
    'sno': "34",
    'scholar': "A.Ranjithkumar",
    'supervisor': "Dr.R.Malayalamurthi",
    'month and year': "Apr-2019"
  },
  {
    'sno': "35",
    'scholar': "A.Baraniraj"

    ,
    'supervisor': "Dr.R.Malayalamurthi"

    ,
    'month and year': "Jul-2019"
  },
  {
    'sno': "36",
    'scholar': "Mohan E",
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Jul-2019"
  },
  {
    'sno': "37",
    'scholar': "Geetha S",
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Nov-2019"
  },
  {
    'sno': "38",
    'scholar': "Selvam B",
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Nov-2019"
  },
  {
    'sno': "39",
    'scholar': "Valarrmathi G",
    'supervisor': "Dr.K.Ramanathan",
    'month and year': "Dec-2019"
  },

  {
    'sno': "40",
    'scholar': "Jamuna R",
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Dec-2019"
  },
  {
    'sno': "41",
    'scholar': "S.Yuvaraj",
    'supervisor': "Dr.R.Malayalamurthi",
    'month and year': "July2020"
  },
  {
    'sno': "42",
    'scholar': "C. Subharaj",
    'supervisor': "Dr.U.Natarajan",
    'month and year': "July2020"
  },
  {
    'sno': "43",
    'scholar': "P.Raja",
    'supervisor': "Dr.R.Malayalamurthi",
    'month and year': "August 2020"
  },
  {
    'sno': "44",
    'scholar': "G. Sathya Priya",

    'supervisor': "Dr.U.Natarajan",
    'month and year': "Octobar-2020"
  },
  {
    'sno': "45",
    'scholar': "D.Sivanesan",
    'supervisor': "Dr.U.Natarajan",
    'month and year': "Nov-2020"
  },
  {
    'sno': "46",
    'scholar': "Ramaswamy S",
    'supervisor': "Dr.J.Selwin Rajadurai",
    'month and year': "June -2020"
  },
  {
    'sno': "47",
    'scholar': "Ponnukrishnan P",
    'supervisor': "Dr.J.Selwin Rajadurai",
    'month and year': "August 2020"
  },
  {
    'sno': "48",
    'scholar': "R.Sundaramoorthy",
    'supervisor': "Dr.K.Manonmani",
    'month and year': "Dec - 2020"
  },



]
const mech_organised = [
  {
    'sno': "1",
    'title': "Inter college Technical Symposium “ SHACKLES 2022",
    'Date': "17.04.2023 & 18.04.2023",
    'resource': "Mr.Anand Thiruvenkatachari, Head, Quality Assurance, Grundfos Pumps India Pvt Ltd",
    'beneficiary': "UG students"

    ,
    'co-ordinator': "Dr.P.Raveendran & Dr.J.Prabakaran"
  }, {
    'sno': "2",
    'title': "Intra college Technical Symposium “FUELS 2023”",
    'Date': "11.04.2023",
    'resource': "Dr.M.Raju, Chief Scientist, CECRI, Karaikudi",
    'beneficiary': "UG students",
    'co-ordinator': "Dr.P.Raveendran & Dr.J.Prabakaran"
  },
  {
    'sno': "3",
    'title': "Inter college Technical Symposium “ SHACKLES 2022”",
    'Date': "10.05.2022",
    'resource': "-",
    'beneficiary': "UG students",
    'co-ordinator': "Dr.S.Sankarapandian"
  },
  {
    'sno': "4",
    'title': "Intra college Technical Symposium “FUELS 2022”",
    'Date': "27.04.2022",
    'resource': "Dr.G.Sreedhar, Scientist, CECRI, Karaikudi",
    'beneficiary': "UG students",
    'co-ordinator': "Dr.S.Sankarapandian"
  },
  {
    'sno': "5",
    'title': "SHACKLES 2K21",
    'Date': "March 2021",
    'resource': "Dr.K.ManonomaniPrincipal-ACGCETKaraikudi"
    ,
    'beneficiary': "UG students",
    'co-ordinator': "Dr. U.Natarajan Dr.B.GuruprasadDr.R.Sarala"

  },
  {
    'sno': "6",
    'title': "TEQIP Sponsored Workshop on “FilterAlgorithm used in Robotics”"
    ,
    'Date': "21.0.2021",
    'resource': "Dr.Wong Wai Kit, Multimedia University (Melaka) Malaysia",
    'beneficiary': "Faculty and PG students",
    'co-ordinator': "Dr.S.Geetha"
  },
  {
    'sno': "7",
    'title': "Webinar on “Outcome based Education (OBE)                       - In and Out",
    'Date': "24.072020",
    'resource': "Dr.J.Selwin Rajadurai",
    'beneficiary': "Faculty of ACGCET, Karaikudi",
    'co-ordinator': "Dr.K.Ramanathan"
  },
  {
    'sno': "8",
    'title': "Webinar on “Leveraging Scinece Direct platform for maximum research Impact”",
    'Date': "15.07 2020",
    'resource': "Experts from M/s Elsevier and M/s GIST, Knimbus",
    'beneficiary': "Faculty and P.G students of ACGCET, Karaikudi",
    'co-ordinator': "Dr.K.Ramanathan"
  },
  {
    'sno': "9",
    'title': "SHACKLES 2K20",
    'Date': "20.02.2020",
    'resource': "Dr.R.Malayalamurthi Principal-ACGCET Karaikudi"
    ,
    'beneficiary': "UG students",
    'co-ordinator': "Dr. U.Natarajan Dr.B.Guruprasad Dr.R.Sarala"

  },
  {
    'sno': "10",
    'title': "Briefing about CO-PO attainment for NBA",
    'Date': "14..02 2020",
    'resource': "Dr.J.Selwin Rajadurai",
    'beneficiary': "Faculty of ACGCET, Karaikudi",
    'co-ordinator': "Dr.K.Ramanathan"
  },
  {
    'sno': "11",
    'title': "Briefing about CO-PO attainment for NBA",
    'Date': "10.02.2019",
    'resource': "Dr.J.Selwin Rajadurai",
    'beneficiary': "Faculty of ACGCET, Karaikudi",
    'co-ordinator': "Dr.K.Ramanathan"
  },
  {
    'sno': "12",
    'title': "TEQIP III Sponsored “Advancement and Automation Industrial Engines”",
    'Date': "04.01.2019",
    'resource': "Dr.K.MURUGAN M/s.Venus Energy Bangalore"
    ,
    'beneficiary': "UG students",
    'co-ordinator': "Dr.B.Guruprasad"
  },
  {
    'sno': "13",
    'title': "Seminar on“Material characterization using XRD”",
    'Date': "22.02.2019",
    'resource': "Faculty from Alagappa University",
    'beneficiary': "P.G students and Faculty"

    ,
    'co-ordinator': "Dr.K.Ramanathan"
  },
  {
    'sno': "14",
    'title': "TEQIP III Sponsored “Advancement of Smart Materials”",
    'Date': "14.02.2019",
    'resource': "Dr.Veeramani Scientist- CECRI Karaikudi"
    ,
    'beneficiary': "UG students",
    'co-ordinator': "Dr.B.Guruprasad"
  },
  {
    'sno': "15",
    'title': "TEQIP III Sponsored SHACKLES 2K19",
    'Date': "28.02.2019",
    'resource': "Dr.Veeramani Scientist- CECRI Karaikudi"
    ,
    'beneficiary': "UG and PG students",
    'co-ordinator': "Dr. U.Natarajan Dr.B.Guruprasad Dr.R.Sarala"

  },
  {
    'sno': "16",
    'title': "TEQIP III Sponsored “Mercedes Engine Diagnosis”",
    'Date': "02.03.2019",
    'resource': "IIT-Bombay",
    'beneficiary': "UG students",
    'co-ordinator': "Dr.B.Guruprasad"
  },
  {
    'sno': "17",
    'title': "TEQIP III Sponsored “Industrial Scenario in Renewable Energy Sector",
    'Date': "22.03.2019",
    'resource': "Dr.B.SRIMANICKAM, MBA., M.Tech., Ph.D., Consultant/Assistant Professor, Dept. R & D Coordinator, Department of Mechanical Engineering, Vel Tech Rangarajan r.Sagunthala R&D Ins. of Sci. & Tech., Chennai 600 062, Tamil Nadu",
    'beneficiary': "UG students",
    'co-ordinator': "Dr.B.Guruprasad"
  },
  {
    'sno': "18",
    'title': "TEQIP III Sponsored Buliding Career- Engineering and Beyond",
    'Date': "01.04.2019",
    'resource': "Er.G.JEGAPRIYAN   M.E., Managing Director ,Tecumseh Products India ,Balanagar 9Township, Hydrabad 500 037",
    'beneficiary': "UG students",
    'co-ordinator': "Dr.B.Guruprasad"
  },
  {
    'sno': "19",
    'title': "Hands on training on “Patent searching and introduction to patent drafting”",
    'Date': "21.06.2019",
    'resource': "Ms.N.Kumutha, IPR Consulatant",
    'beneficiary': "Faculty of ACGCET, Karaikudi",
    'co-ordinator': "Dr.K.Ramanathan"
  },
  {
    'sno': "20",
    'title': "Hands on training on “Patent searching and introduction to patent drafting”",
    'Date': "21.06  2019",
    'resource': "Ms.N.Kumutha, IPR Consulatant,",
    'beneficiary': "Faculty of ACGCET, Karaikudi",
    'co-ordinator': "Dr.K.Ramanathan"
  },
  {
    'sno': "21",
    'title': "AICTE-QIP FDP on “Modelling and Optimization Techniques for Engineering Applications”",
    'Date': "11.11.2018-25.11.2018",
    'resource': "-",
    'beneficiary': "Faculty Members",
    'co-ordinator': "Prof. T. Raja Vijay Dr. C.R. Senthil Kumar"

  },
  {
    'sno': "22",
    'title': "TEQIP Sponsored Workshop on “Project based learning through E-Yantra”"
    ,
    'Date': "15.09.2018 & 16.09.2018",
    'resource': "Mr.K Thiyagarajan, Lecturer / Instrumentation & Control Engg,Annamalai Polytechnic College, Chettinad."
    ,
    'beneficiary': "UG students",
    'co-ordinator': "Dr.S.Geetha"
  },
  {
    'sno': "23",
    'title': "FDP on “Modeling and Optimization Techniques for Engineering Applications”",
    'Date': "12thto 25th November 2018"
    ,
    'resource': "Faculty from NITs and Government Institutions and Engineers from Industry",
    'beneficiary': "Faculty of Engineering and Polytechnic colleges",
    'co-ordinator': "Dr.K.Ramanathan & Prof. T. Rajavijay"

  },
  {
    'sno': "24",
    'title': "AICTE-QIP sponsored Faculty Development programme  on Application of Finite Element Analysis (AFEA-2018)",
    'Date': "12thto 25th February 2018",
    'resource': "Faculty from NITs and Government Institutions and Engineers from Industry",
    'beneficiary': "Faculty of Engineering and Polytechnic colleges",
    'co-ordinator': "Dr.S.Jayabal & Dr.K.Ramanathan"
  },
  {
    'sno': "25",
    'title': "TEQIP III Sponsored “How to Solve Corporate problems in engineering way”",
    'Date': "22.07.2018",
    'resource': "Mr. GURUCHARAN RAGHUNATHAN,PRODUCT MANAGER SHIELD SQUARE BANGALORE."
    ,
    'beneficiary': "UG students",
    'co-ordinator': "Dr.B.Guruprasad"

  },

  {
    'sno': "26",
    'title': "TEQIP Sponsored National Conference on “Contemporary Approaches in Design and Manufacturing”",
    'Date': "26.04.2018",
    'resource': "-",
    'beneficiary': "PG students and Faculty’s",
    'co-ordinator': "Prof. V. Jawahar Prof. T. Raja Vijay"

  },
  {
    'sno': "27",
    'title': "TN GOVT Sponsored Two days workshop on “Industrial safety”",
    'Date': "26.03.2018 & 27.03.2018",
    'resource': "NATIONAL FIRE AND SAFETY COLLEGE, KARAIKUDI",
    'beneficiary': "UG students",
    'co-ordinator': "Dr. U.Natarajan Dr.B.Guruprasad"

  },
  {
    'sno': "28",
    'title': "TEQIP III Sponsored”SHAKLES-18”",
    'Date': "06.03.2018",
    'resource': "T.Kartheek/ Madhan kumar EID parry- Chennai"
    ,
    'beneficiary': "UG and PG students",
    'co-ordinator': "Dr. U.Natarajan Dr.B.Guruprasad Dr.R.Sarala"

  },
  {
    'sno': "29",
    'title': "TEQIP III Sponsored “FUEL-2K18” technical symposium",
    'Date': "25.07.2018 & 26.07.2018",
    'resource': "Er.B.Arokiyaraj Fernando AGM- Quality,  Sanmar metal ltd, Trichy"
    ,
    'beneficiary': "UG and PG students",
    'co-ordinator': "Dr. U.Natarajan Dr.B.Guruprasad Dr.R.Sarala"

  },
  {
    'sno': "30",
    'title': "TEQIP III Sponsored “FUEL-2K17” technical symposium",
    'Date': "10.10.2017",
    'resource': "V.Madhukar Head HR, SPIC Tuticorin"
    ,
    'beneficiary': "UG and PG students",
    'co-ordinator': "Dr. U.Natarajan Dr.B.Guruprasad Dr.R.Sarala"

  },
  {
    'sno': "31",
    'title': "Edusat programmes for thermodynamics",
    'Date': "19.09.2017",
    'resource': "ANNA UNIVERSITY",
    'beneficiary': "UG students",
    'co-ordinator': "Dr.N.Babu"
  },
  {
    'sno': "32",
    'title': "Fire Safety Awareness Programme",
    'Date': "10.03.2017",
    'resource': "District Officer Fire Safety and Rescue Department, Sivagangai"
    ,
    'beneficiary': "UG students",
    'co-ordinator': "Dr.S.Geetha"
  },
  {
    'sno': "33",
    'title': "Five Days Training Cum Skill development Programme on Apiculuture",
    'Date': "19.09.2016 to  23.09.2016"
    ,
    'resource': "Mr.S.Jeyaraja Kumaradoss Incharge of state bee Keeping extension, Kuzhithurai"
    ,
    'beneficiary': "UG and PG students",
    'co-ordinator': "Dr.S.Geetha"
  },
  {
    'sno': "34",
    'title': "TEQIP Sponsored Workshop on “Robotics Competitions based Education in Engineering (RoCK- BEE)"
    ,
    'Date': "14.09.2016 to 15.09.2016",
    'resource': "Dr. Subir Kumar Saha,Naren Gupta Chair Professor,Department of Mechanical Engineering, Indian Institute of Technology, Delhi.Dr .S.Saravanaperumal,Assistant Professor,Department of Mechanical Engineering, Thiagarajar College of Engineering,Madurai."
    ,
    'beneficiary': "Faculty and PG students",
    'co-ordinator': "Dr.S.Geetha"
  },
  {
    'sno': "35",
    'title': "TEQIP Sponsored Workshop on “Recent trends in Robot Technology”"
    ,
    'Date': "7.01.2016",
    'resource': "Dr Somashekhar S. Hiremath Professor Department of Mechanical Engineering, Indian Institute of Technology, Madras"
    ,
    'beneficiary': "UG and PG students",
    'co-ordinator': "Dr.S.Geetha"


  },
  {
    'sno': "36",
    'title': "TEQIP sponsored workshop on “Sheet Metal Forming”",
    'Date': "15th April 2016",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Non teaching technical staffs",
    'co-ordinator': "K.Ramanathan"
  },
  {
    'sno': "37",
    'title': "Staff Development Programme on “Hands on training on Basic Welding”",
    'Date': "20thto 24th June 2016",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Non teaching technicalstaffs",
    'co-ordinator': "K.Ramanathan"
  },
  {
    'sno': "38",
    'title': "Seminar on “Material characterization using XRD”",
    'Date': "5th August 2016",
    'resource': "Scientist from CECRI,Karaikudi",
    'beneficiary': "P.G students and Faculty",
    'co-ordinator': "P.Perumal"
  },
  {
    'sno': "39",
    'title': "SDP on “First Aid & Home Nursing”",
    'Date': "22ndto 23rd August 2016",
    'resource': "Expert from St.John Ambulance, Trichy"

    ,
    'beneficiary': "Non teaching technical staffs",
    'co-ordinator': "K.Ramanathan"
  },
  {
    'sno': "40",
    'title': "AICTE Sponsored FDP on”Entrepreneurship Development",
    'Date': "10thto 23rdFebruary 2014",
    'resource': "Tamilnadu Entrepreneurship Development Cell,Madurai",

    'beneficiary': "Faculty of Engineering and Polytechnic colleges",
    'co-ordinator': "K.Ramanathan"
  },
  {
    'sno': "41",
    'title': "TEQIP Sponsored Workshop on “Surface protection of metals”",
    'Date': "28thto 30thOctober2013",
    'resource': "Scientist from CECRI,Karaikudi",
    'beneficiary': "Faculty of Engineering and Polytechnic colleges",
    'co-ordinator': "Dr.A. Elango & Dr.K.Ramanathan"
  },
  {
    'sno': "42",
    'title': "Workshop on Surface Engineering",
    'Date': "24th March 2008",
    'resource': "Scientist from CECRI,Karaikudi",
    'beneficiary': "Faculty of Engineering and Polytechnic colleges",
    'co-ordinator': "A.Elango"
  },
  {
    'sno': "43",
    'title': "TEQIP sponsored training on Training on Un",
    'Date': "15-19, October 2007",
    'resource': "Faculty of ACCET,Karaikudi",
    'beneficiary': "Students of networking engineering colleges",
    'co-ordinator': "S.Jayabal & S.Selvaraj"


  },
  {
    'sno': "44",
    'title': "TEQIP sponsored training on Advanced Manufacturing Techniques",
    'Date': "18-22, June 2007",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "S.Jayabal"
  },
  {
    'sno': "45",
    'title': "TEQIP sponsored training on Gas welding and Gas cutting Practice",
    'Date': "11-15 June 2007"
    ,
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "K.Ramanathan"
  },
  {
    'sno': "46",
    'title': "TEQIP sponsored training on Gas welding and Gas cutting Practice",
    'Date': "11-15 June 2007",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "K.Ramanathan"
  },
  {
    'sno': "47",
    'title': "TEQIP sponsored training on Manufacturing Techniques",
    'Date': "04-08, June 2007",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "S.Jayabal"
  },
  {
    'sno': "48",
    'title': "TEQIP sponsored training on Molding and Casting Practices",
    'Date': "21-25, May 2007",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "S.Jayabal"
  },
  {
    'sno': "49",
    'title': "TEQIP sponsored training on Sheet Metal working",
    'Date': "09-15, May 2007",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "S.Jayabal"
  },
  {
    'sno': "50",
    'title': "TEQIP sponsored training on Gas Welding and Gas Cutting Practice",
    'Date': "14-May-07",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",

    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "K.Ramanathan"


  },
  {
    'sno': "51",
    'title': "TEQIP sponsored training on Plastic Wire Knitting for furniture",
    'Date': "27-ov 2006 to 01-Dec 2006",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "A.Athijayamani"
  },
  {
    'sno': "52",
    'title': "TEQIP sponsored training on Special Purpose Machines",
    'Date': "31- July 2006 to 04-August 2006",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "S.Jayabal"
  },
  {
    'sno': "53",
    'title': "TEQIP sponsored training on CNC programming and operations",
    'Date': "19-Dec-2005",
    'resource': "Faculty and Technical staffs of ACCET,Karaikud",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "A.Athijayamani"
  },
  {
    'sno': "54",
    'title': "TEQIP sponsored training on Machine Tool Operation",
    'Date': "14-18, Nov 2005",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "S.Jayabal"
  },

  {
    'sno': "55",
    'title': "TEQIP sponsored training on Arc Welding Practice",
    'Date': "07-11, Nov 2005",
    'resource': "Faculty and Technical staffs of ACCET,Karaikudi",
    'beneficiary': "Public ( Service to the community)",
    'co-ordinator': "A.Elango"
  },
]

const mech_objectives_of_coe = [
  {
    id: "1",
    point:
      "To make Additive Technologies",
  },
  {
    id: "2",
    point:
      "To fabricate light nano structured alloys based on Aluminium,Copper and Shape memory alloys",
  },
  {
    id: "3",
    point:
      "To model and forecast the properties of new materials and their technologies",
  },
  {
    id: "4",
    point:
      "To fabricate thin film and coating technologies",
  },
];
const mech_coe_researches = [
  {
    id: "1",
    point:
      "Integrated WAAM Robotic Cell",
  },
  {
    id: "2",
    point:
      "Manual MIG Welding Machine",
  },
  {
    id: "3",
    point:
      "Double Disc polishing Lapping and metallurgical microscope testing facility for macro study",
  },
  {
    id: "4",
    point:
      "Welding Simulator",
  },
  {
    id: "5",
    point:
      "Laser and Rotary Measurement system ( Laser Interferometer)",
  },
  {
    id: "6",
    point:
      "Thermal Evaporation Set-up for Thin film Deposition",
  },
];
const mech_phd_facilities = [
  {
    'id': "1",
    'point': "Tensile testing machine for Composite and Plastic material."

  },
  {
    'id': "2",
    'point': "Impact testing machine for Composite and Plastic material."
  },
  {
    'id': "3",
    'point': "Thermo gravimetric analysis."
  },
  {
    'id': "4",
    'point': "Pin on disc Tribometer."
  },
  {
    'id': "5",
    'point': "Physical Vapour Depositing machine"
  },
  {
    'id': "6",
    'point': "Laser interferometer"
  },
  {
    'id': "7",
    'point': "Bottom pouring stir casting furnace"
  },
  {
    'id': "8",
    'point': "Vibration test rig"
  },
  {
    'id': "9",
    'point': "Energy gadgets for Solar Energy Measurement"

  },
  {
    'id': "10",
    'point': "Integrated Robotic Rapid WAAM as per Industry 4.0 with accessories"

  },
]

      //mech association page data from below

const mech_stud_achievements = [
  {
    'id': '1',
    'program': 'ACGCET GEMS Achievement 2024',
    'pdf': 'https://drive.google.com/file/d/1NZnFnv3PKu-mQcAJ1uaCtcxG1IlNwoOp/view?usp=sharing'
  }
]
// const mech_asso_logo_pic = require("../assets/TEMP_MECH_ASSETS/logo.jpeg")
const mech_asso = {
  //  name: "Dr.C.Uma Rani",
  //  designation: "Head of the Department, CSE",
   pic: " https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/mech_asso_logo.webp", //mech_asso_logo_pic 
  content:
    `The Department of Mechanical Engineering nurtures a vibrant and proactive 
student association committed to promoting technical excellence, 
innovation, and leadership among students. The association plays a pivotal 
role in organizing diverse academic and technical initiatives, including the 
Intra-Departmental Symposium – Fuels and the Inter-Collegiate National 
Level Technical Symposium – Shackles, both serving as premier platforms 
for knowledge exchange and professional development. 
Through expert-led workshops, technical events, and interactive sessions, 
the association enhances students’ practical learning experiences and 
fosters awareness of emerging trends in mechanical engineering. By 
cultivating teamwork, creativity, and analytical thinking, the association 
continues to uphold the department’s tradition of excellence and 
contributes significantly to the holistic growth of its students.`,
};

// const shackels1 = require("../assets/TEMP_MECH_ASSETS/shackles.png");
// const shackels2 = require("../assets/TEMP_MECH_ASSETS/shackles3.png");
// const shackels3 = require("../assets/TEMP_MECH_ASSETS/shackles2.png");
// const iv1 = require("../assets/TEMP_MECH_ASSETS/iv1.png");
// const iv2 = require("../assets/TEMP_MECH_ASSETS/iv2.png");
// const iv3 = require("../assets/TEMP_MECH_ASSETS/iv3.png");
// const iv4 = require("../assets/TEMP_MECH_ASSETS/iv4.png");
// const iv5 = require("../assets/TEMP_MECH_ASSETS/iv5.png");
const shackles = [
  {
    id: "1",
    heading: "Shackles 25-26 ",
    // date: "17.07.2025",
    // organizer: "Alagappa Incubation Forum, ACGCET",
    content:
      "The Mechanical Engineering Association successfully organized SHACKLES 25–26, the National Level Technical Symposium, on 23rd and 24th October 2025. The event provided an excellent platform for students from various institutions to showcase their technical knowledge, creativity, and innovative ideas through workshops, technical and non-technical competitions, and special events. With enthusiastic participation and expert guidance, the symposium promoted hands-on learning, teamwork, and professional growth, making it a memorable and impactful event for all participants.",
    
      images: [
        "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/shackles_mech_sympo.webp",
        "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/shackles_mech_sympo-2.webp ",
        "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/shackles_mech_sympo-3.webp",
    //  shackels1,shackels2,shackels3
    ]
  }
]

const mech_iv = [
  {
    id: "4",
    heading: "Kerala Electrical & Allied Engineering Co. Ltd. (KEL), Ernakulam",
    "sub-head": "17th February 2026",
    pic: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/iv-1.webp",
    content_1: "",
    content_2: "",
  },
  {
    id: "5",
    heading: "Rabwin Industries, Coimbatore",
    "sub-head": "3rd March 2026",
    pic: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/iv-2.webp",
    // content_1:"On 3rd March 2026, the Department of Mechanical Engineering organized an industrial visit to Rabwin Industries, Coimbatore, for IV semester B.E. Mechanical Engineering students. The visit provided exposure to precision manufacturing, machining, fabrication, and quality testing processes, helping students understand the importance of accuracy, consistency, and industrial standards in modern engineering production.",
    content_2: "",
  },
  {
    id: "6",
    heading: "LMW, Coimbatore ",
    "sub-head": "17th March 2026",
    pic: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/iv-3.webp",
    content_1: "",
    content_2: "",
  },
  {
    id: "7",
    heading: "Benchmark Chocolate Factory, Ooty",
    "sub-head": "18th March 2026",
    pic: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/iv-4.webp",
    content_1: "",
    content_2: "",
  },
  {
    id: "8",
    heading: "Kerala Electrical & Allied Engineering Co. Ltd. (KEL), Ernakulam",
    "sub-head": "25th March 2026",
    pic: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/iv-5.webp",
    content_1: "",
    content_2: "",
  },
]

// const sa1 = require("../assets/TEMP_MECH_ASSETS/sa1.png");
// const sa2 = require("../assets/TEMP_MECH_ASSETS/sa2.png");
// const sa3 = require("../assets/TEMP_MECH_ASSETS/sa3.png");
// const sa4 = require("../assets/TEMP_MECH_ASSETS/sa4.png");
// const sa5 = require("../assets/TEMP_MECH_ASSETS/sa5.png");
// const sa6 = require("../assets/TEMP_MECH_ASSETS/sa6.png");
// const sa7 = require("../assets/TEMP_MECH_ASSETS/sa7.png");
// const sa8 = require("../assets/TEMP_MECH_ASSETS/sa8.png");
// const sa9 = require("../assets/TEMP_MECH_ASSETS/sa9.png");
// const sa10 = require("../assets/TEMP_MECH_ASSETS/sa10.png");
// const sa11= require("../assets/TEMP_MECH_ASSETS/sa11.png");








const mech_asso_achievements = [
  {
    'id': '10',
    'heading': 'SSL P26 Leadership Award Winners',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-1.webp",
    'content_1': 'The Mechanical Engineering team from Alagappa Chettiar Government College of Engineering and Technology, Karaikudi, clinched the First Prize and the Best Leadership Award at Stella Marys College Student Startup Leadership Programme (SSL P26) under the leadership of A.R. Honey Rose.',
    'content_2': 'With participation from teams across Tamil Nadu and a focus on innovation, leadership, entrepreneurship, and business development, this recognition highlights the departments commitment to nurturing future-ready professionals for startup ecosystems and technological advancement.',
    'butt_text': 'knowmore',
  },
  {
    'id': '11',
    'heading': 'Inter-College Symposium Excellence',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-2.webp",
    'content_1': 'Second-year Mechanical Engineering students Sowmiya Priya G.V. and Padmalosa S. secured First Prize in paper presentation at the K.S. Rangasamy College symposium held from 12.02.2026 to 14.02.2026.',
    'content_2': 'Archana V also won First Prize at the ATNOUS25 National Fire and Safety College symposium, showcasing exemplary research and presentation skills that elevated the departments reputation on a wider academic platform.',
    'butt_text': 'knowmore',
  },
  {
    'id': '12',
    'heading': 'Grand Smart India Hackathon Finalists',
    'sub-head': '',
    'pic':"https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-3.webp",
    'content_1': 'The Smart Hackers 01 team - Poovovika M. (Team Lead), Parameswaran S., Purushothaman T., Paul Raj G., Nithyasri A., and Sowmiya S. - advanced to the Grand Finale of Smart India Hackathon 2025 (08.10.2025 to 12.10.2025), mentored by Prof. M. Perumal.',
    'content_2': 'Representing Alagappa Chettiar Government College of Engineering and Technology, Karaikudi, the team demonstrated strong problem-solving ability, technical innovation, and collaboration under pressure, reflecting the institutions strength in engineering solutions for national challenges.',
    'butt_text': 'knowmore',
  },
  {
    'id': '13',
    'heading': 'Formulated Kart Design Challenge Triumph',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-4.webp",
    'content_1': 'The Storm Breakers team, comprising 25 Mechanical Engineering students, delivered an outstanding performance at Formulated Kart Design Challenge Season 9 organized by FM and AE at Kari Motor Speedway, Coimbatore.',
    'content_2': 'Guided by Prof. G. Udhayakumar, Prof. A. Syed Abdul, and team leads Dr. Senthil and Dr. Geetha, the team secured AIR 13 in endurance, AIR 5 in cost, and AIR 9 in acceleration, highlighting excellence in design, teamwork, and practical engineering.',
    'butt_text': 'knowmore',
  },
  {
    'id': '14',
    'heading': 'TN IMPACT Hackathon 2026 Champions',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-5.webp",
    'content_1': 'Mechanical Engineering students emerged victorious at TN IMPACT Hackathon 2026 hosted by KIT - Kalaignar Karunanidhi Institute of Technology, competing against nearly 2,000 participants from colleges across Tamil Nadu.',
    'content_2': 'Their innovative prototype impressed both internal and external juries, earning top honors and marking a second consecutive win after last years success with Dassault Systemes, Pune.',
    'butt_text': 'knowmore',
  },
  {
    'id': '15',
    'heading': 'MECHNOTRON-CIT Symposium',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-6.webp",
    'content_1': 'Second-year Mechanical Engineering students participated in the Mechatron symposium organized by Coimbatore Institute of Technology, Coimbatore, and showcased technical knowledge and practical skills in multiple events.',
    'content_2': 'Notable wins included Mohammed Abdullah J (1st prize in Welding), Jai Krishna (1st prize in Reverse Rumble), and Kaushik Kumar S R with Hariharan N (2nd prize in Autologix), bringing recognition to the institution.',
    'butt_text': 'knowmore',
  },
  {
    'id': '16',
    'heading': 'MECHATRONZ 2k26 - Syed Ammal Engineering College',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-7.webp",
    'content_1': 'Mechanical Engineering students participated in the Mechatronz 2K26 symposium at Syed Ammal Engineering College, presenting their technical knowledge, presentation skills, and innovative ideas.',
    'content_2': 'Ashika M and Dhanashka secured 2nd prize in Paper Presentation, while other participants also gained valuable experience and contributed to the institutions recognition through teamwork and dedication.',
    'butt_text': 'knowmore',
  },
  {
    'id': '17',
    'heading': 'TECHNOSAFE26 - National Fire and Safety College',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-8.webp",
    'content_1': 'Students participated in TECHNOSAFE26, a national-level symposium conducted by National Fire and Safety College, to enhance domain knowledge and demonstrate their skills in fire and safety.',
    'content_2': 'Archana V secured 1st prize in Paper Presentation, and several other students actively participated, bringing recognition to the institution through dedication and excellence.',
    'butt_text': 'knowmore',
  },
  {
    'id': '18',
    'heading': 'SYNERGY 2026 - NIT Trichy Symposium',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-9.webp",
    'content_1': 'Mechanical Engineering students participated in SYNERGY 2026 at National Institute of Technology, Tiruchirappalli, where events included technical competitions such as Technical Quiz.',
    'content_2': 'Prakash P secured 3rd prize and Prem K secured 2nd prize in Technical Quiz. Along with other active participants, their accomplishments reflected enthusiasm and technical expertise.',
    'butt_text': 'knowmore',
  },
  {
    'id': '19',
    'heading': 'GYAN MITRA 26 - Mepco Schlenk Engineering College',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-10.webp",
    'content_1': 'Mechanical Engineering students showcased technical knowledge and presentation skills at GYAN MITRA 26, the annual symposium hosted by Mepco Schlenk Engineering College, and won the Runner-Up prize in the PPT competition.',
    'content_2': 'Gopika S secured 2nd prize in Machine Drawing using AutoCAD, further demonstrating the participants technical expertise, creativity, and commitment to excellence.',
    'butt_text': 'knowmore',
  },
  {
    'id': '20',
    'heading': 'SAEISS Drone Development Challenge 2025',
    'sub-head': '',
    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/mech_asso/student_achivement-11.webp",
    'content_1': 'The Department of Mechanical Engineering at Alagappa Chettiar Government College of Engineering and Technology, Karaikudi, proudly participated in the SAEISS Drone Development Challenge (DDC) 2025 in the Regular Class category at KCG College of Technology, Chennai, from 20.10.2026 to 22.10.2026, under the guidance of Prof. P. Perumal. The multidisciplinary team comprised IV Year MECH students Anees Ahamed T, Jeffrey Shakil V, Bavina M, and Mathan Raghul B; III Year MECH students Thiruvenkatam K and Joel Kirubakaran C; IV Year ECE students Dhanaprasath K and Shahid Affan S; and IV Year EEE students Preethi Poornima D and Sathesh Raj R.',
    'content_2': 'This prestigious Collegiate Design Series event challenged students to design, fabricate, and demonstrate fixed-wing UAVs meeting stringent mission requirements for payload carriage, flight stability, and cargo delivery. The team showcased exceptional expertise in aerodynamics, electric propulsion systems, and control technologies while adhering to DDC rules on payload bays and flight circuits, demonstrating outstanding interdisciplinary collaboration and technical innovation.',
    'butt_text': 'knowmore',
  }
]

export {
  mech_dept_menu,
  mech_fac_profiles,
  mech_sup_profiles,
  mech_mission,
  mech_vision,
  mech_progs,
  mech_outcomes,
  mech_peo,
  mech_spec_outcomes,
  mech_labs,
  mech_dept_events,
  mech_rankers,
  mech_lib_profiles,
  mech_phd_facilities,
  mech_research_phd,
  mech_organised,
  mech_objectives_of_coe,
  mech_coe_researches,
  mech_stud_achievements,
  mech_asso,
  shackles,
  mech_iv,
  mech_asso_achievements
};
